import {
    HierarchyPath,
    hierarchyPathToIds,
} from "../../../../../components/TreeCheckboxGroup";
import { Group } from "../../../../../interfaces/Session";
import { pathToClassroomId, pathToStudentId } from "../EditPlaylist/utils";

export const originallyCheckedStudentsInPath = (
    path: HierarchyPath,
    originallyCheckedStudents: string[],
    classrooms: Group[]
): string[] => {
    if (isStudent(path)) {
        const id = pathToStudentId(path);
        if (originallyCheckedStudents.some((studentId) => studentId === id))
            return [id];
        return [];
    } else {
        const classroomId = pathToClassroomId(path);
        const studentsInClassroom = classrooms
            .find((classroom) => classroom.id === classroomId)
            ?.students.map((student) => student.id);
        if (!studentsInClassroom) return [];
        return originallyCheckedStudents.filter((studentId) =>
            studentsInClassroom.includes(studentId)
        );
    }
};

export const isStudent = (path: HierarchyPath): boolean => {
    return hierarchyPathToIds(path).length === 2;
};

export const currentlyChecked =
    (checkedStudents: HierarchyPath[]) => (student: string) =>
        checkedStudents.map((path) => pathToStudentId(path)).includes(student);
